// import ErrorModal from '../modals/ErrorModal';
//! yopu need to convert your forms ==> Formik VS React-BootStrap import { Label } from 'react-bootstrap';
import './Login.style.css';
import './Auth.style.scss';
import './RegisterMobile.scss';

import { ArrowForward, Visibility, VisibilityOff } from '@mui/icons-material';
import { Button } from '@mui/material';
//import TextField from '@mui/material/TextField';
import React, { useEffect, useRef, useState } from 'react';
import ReactCodeInput from 'react-code-input';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import axios from '../../Api/axios';
// import { DELAY } from '../../config';
import Logo from '../../data/Logo';
import { DrawLine, RegisterSvgDraw, RightFlech } from '../../data/SVGs';
import useAuth from '../../hooks/useAuth';
import { PropsReactCodeInput, PropsReactCodeInputMobile } from '../../Styles/componentStyles';
import ConnectOAuth2 from './ConnectOAuth2';
const LOGIN_URL_checkCodeOTP = 'auth/checkCodeOTP';
const LOGIN_URL_2FA = 'auth/login_2FA';
import { Controller,useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import useAuthSetState from '../../hooks/useAuthSetState';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
import useWindowSize from '../../hooks/useWindowSize';
import { isValidEmail } from '../../Utils/validationUtils';
import { buttonStyles, buttonStylesBlue } from '../docsAdministrative/JsObjectStyles';
import NavbarHome from '../shared/Navbar/NavbarHome';
import { IconTextField,TextFieldComponent } from '../shared/ReusableSmallComponents';

function Login2FA() {
    const {setAuthState,RedirectRoleAndFromBased} = useAuthSetState();
    const {persist, setPersist } = useAuth();
    const navigate = useNavigate();
    // const userRef = useRef();//focus on the first input when the component load
    const errRef = useRef();//focus on error
    const divRef = useRef(null);
    const [width, setWidth] = useState(0);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [otp, setOtp] = useState();
    const [AT, setAT] = useState('');
    const [signupErrorEmail, setSignupErrorEmail] = useState('');
    const [emailValid, setEmailValid] = useState(false);
    const [passwordShown, setPasswordShown] = useState(false);
    const { i18n } = useTranslation();
    // const [confirmationCode, setConfirmationCode] = useState();
    const [show, setShow] = useState(false);
    const {device}=useWindowSize();
    const { control} = useForm();
    const target = useRef(null);
    usePersistedLanguage();
    useEffect(() => {
        const updateWidth = () => {
            if (divRef.current) {
                const rect = divRef.current.getBoundingClientRect();
                setWidth(rect.width);
            }
        };
        // Call the function initially to set the initial width
        updateWidth();
        // Attach the event listener to update the width when the window is resized
        window.addEventListener('resize', updateWidth);
        // Cleanup the event listener when the component unmounts
        return () => {
            window.removeEventListener('resize', updateWidth);
        };
    }, [divRef]);

    useEffect(() => {
        localStorage.setItem('persist', persist);
    }, [persist]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes

    const checkCodeOTP = async (e) => {
        e.preventDefault();
        console.log('OTP Submitted');
        try {
            const response = await axios.post(LOGIN_URL_checkCodeOTP,
                { confirmationCode: otp },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${AT}`
                    },
                    withCredentials: true
                }
            );
            console.log(JSON.stringify(response?.data));
            setAuthState({responseData: response.data});
            RedirectRoleAndFromBased({role: response?.data?.user?.role});
            setEmail('');
            setPassword('');
        } catch (error) {
            console.log(error);
            if (!error.response) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text:'No Server Response',
                });
            }
            else if (error.response?.status >= 400) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text:error.response.data.error,
                });
            }
            errRef.current.focus();
        }
    };

    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(LOGIN_URL_2FA,
                { email, password },
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }
            );
            console.log(JSON.stringify(response?.data));
            const accessToken = response?.data?.accessToken;
            if (response?.status == 200) {
                // 200 = OK == 2FA = OTP sent
                setAT(accessToken);
                console.log('AT setted', accessToken);
            }
            else if (response?.status == 202) {
                // 202 = Accepted == Normal Login = AT & RT recieved
                setAuthState({responseData: response.data});
                RedirectRoleAndFromBased({role: response?.data?.user?.role});
                setEmail('');
                setPassword('');
            }
        } catch (error) {
            console.log(error);
            if (!error.response) {
                // setErrorMessage('No Server Response');
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text:'No Server Response',
                });
            }
            else if (error.response?.status >= 400) {
                // setErrorMessage(error.response.data.error);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text:error.response.data.error,
                });
            }
            // * set focs on error msg, so screen reador can read it
            errRef.current.focus();
        }
    };

    const togglePersist = () => {
        setPersist(prev => !prev);
    };

    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };

    const handlePinChange = pinCode => {
        console.log(pinCode);
        setOtp(pinCode);
    };

    function validateEmail(email) {
        if (!isValidEmail(email)) {
            setSignupErrorEmail('Email non valide');
            setEmailValid(false);
        }
        else {
            setEmailValid(true);
            setSignupErrorEmail('');
        }
    }

    return (
        <div className='HomePageInscription'>
            {device!='desktop'&&
            <NavbarHome />
            }
            {device=='desktop' &&
            <div className='FirstRectangle'>
                <div className='LogoTitle'>
                    <div className='frame0RegisterStepOne'>
                        <Logo
                            width='198px'
                            height='54px'
                        />
                    </div>
                    <div className='frame1RegisterStepOne'>
                        <h3
                            className='BonjourTitle'
                            style={{color:'rgba(39, 45, 60, 1)'}}
                        > {i18n.t('Connectez vous à ')}
                            <span
                                style={{
                                    fontFamily: 'Lato',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    fontSize: '48px',
                                    display:'inline',
                                    lineHeight: '56px',
                                    color:'rgba(33, 77, 206, 1)'}}
                            > {i18n.t('High Tech Hires ')}
                            </span> {i18n.t('communauté!')}
                        </h3>
                    </div>
                </div>
                <div className='DrawIconeStyle'>
                    <RegisterSvgDraw />
                </div>
            </div>
            }
            <div className='rect123434'>
                {device=='desktop' &&
                <div className='BtnSinscrire'>
                    <span className='Vousnavezpas'>{i18n.t('Vous n\'avez pas de compte ?')} &nbsp; &nbsp;</span>
                    <div className='BtnSinscrireS'>
                        <Button
                            variant="outlined"
                            //style={{
                            //    width: '131px',
                            //    borderRadius: '8px',
                            //}}
                            style={{...buttonStyles(false),...{height:'38px'}}}
                            onClick={() => navigate('/register')}
                            startIcon={<ArrowForward />}
                        >
                            {i18n.t('S\'inscrire')}
                        </Button>
                    </div>
                </div>
                }
                {AT ?
                    <form onSubmit={handleLoginSubmit}>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                padding: '0px',
                                gap: '24px',
                                width: '430px',
                                height: '368px',
                            }}
                        >
                            <h4 className='Vemail'>{i18n.t('Vérifier l\'adresse e-mail')}</h4>
                            <div className='codevemail'>
                                <p className='Textcodevemail'>{i18n.t('Un message avec un code de vérification a été envoyé à votre adresse e-mail. Veuillez entrer le code pour continuer.')}</p>
                                <div className='VemailBoxCode'>
                                    {device=='desktop' ?
                                        <ReactCodeInput
                                            id="pinCode"
                                            type='number'
                                            fields={4}
                                            value={otp}
                                            onChange={handlePinChange}
                                            className='reactInput'
                                            {...PropsReactCodeInput}
                                        />
                                        :
                                        <ReactCodeInput
                                            id="pinCode"
                                            type='number'
                                            fields={4}
                                            value={otp}
                                            onChange={handlePinChange}
                                            className='reactInput'
                                            {...PropsReactCodeInputMobile}
                                        />
                                    }
                                </div>
                            </div>
                            <div className='VerifBtnVemail'>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    style={{
                                        ...buttonStylesBlue(),...{width:'100%'}
                                    }}
                                    startIcon={<RightFlech />}
                                    ref={target}
                                    onClick={(e) => {
                                        checkCodeOTP(e);
                                        setShow(!show);
                                    }}
                                > {i18n.t('Vérifier')}
                                </Button>
                            </div>
                        </div>
                    </form>
                    :
                    <form className='ConnectForm'>
                        <h4 className='IdentifiezVous'>{i18n.t('Identifiez-vous')}</h4>
                        {device!='desktop' &&
                        <RegisterSvgDraw
                            width={'80%'}
                            height={'70%'}
                        />
                        }
                        <div className='FormIdentifiezVous'>
                            <div className='IdentifiezVous1'>
                                <Controller
                                    render={() =>
                                        <TextFieldComponent
                                        //id="outlined-size-small"
                                        //defaultValue="Email"
                                        //size="small"
                                        //type={'text'}
                                            //style={{width:'407px',borderRadius: '8px',}}
                                            label="Email"
                                            name="emailLogin"
                                            onChange={e => {
                                                setEmail(e.target.value);
                                                validateEmail(e.target.value);
                                            }}
                                            style={{width:'100%'}}
                                            sx={{
                                                '& > :not(style)': {borderRadius: '8px'},
                                            }}
                                            //defaultValue=""
                                            autoFocus={true}
                                            // ref={userRef}
                                            //value={email}
                                            error={signupErrorEmail == '' ? false : true}
                                            // helperText={signupErrorEmail} //* FZ veut juste le rouge
                                            required
                                        />
                                    }
                                    name="emailLogin"
                                    control={control}
                                    value={email}
                                    //defaultValue=""
                                />
                                {/* PS ::  link of the issue in textfield https://stackoverflow.com/questions/63973773/error-when-setting-an-input-in-reactjs-label-is-over-overwrites-the-value-of*/}
                                <Controller
                                    render={() =>
                                        <IconTextField
                                            type={passwordShown ? 'text' : 'password'}
                                            //style={{width:'407px'}}
                                            label={i18n.t('Mot de Passe')}
                                            style={{width:'100%'}}
                                            sx={{
                                                '& > :not(style)': {borderRadius: '8px'},
                                            }}
                                            name="paswordLogin"
                                            iconEnd={passwordShown
                                                ? <VisibilityOff onClick={togglePassword} />
                                                : <Visibility onClick={togglePassword} />}
                                            onChange={e => {
                                                setPassword(e.target.value);
                                            }}
                                        />}
                                    name="paswordLogin"
                                    control={control}
                                    value={password}
                                    //defaultValue=""
                                />
                            </div>
                            {/*</Box>*/}
                            <div className='cgu' >
                                {/* //! any input should have a label [Accessibility] */}
                                <div className='checkrectangle'>
                                    <input
                                        type="checkbox"
                                        ref={errRef}
                                        className="checkSty"
                                        id="persist"
                                        onChange={togglePersist}
                                        style={{borderRadius:'5px',
                                            border: '2.2px solid #777777',
                                            width: '18px',
                                            height: '18px'
                                        }}
                                        checked={persist}
                                        required
                                    />
                                    <p className='Moublie'>{i18n.t('Se souvenir du mot de passe')} &nbsp; &nbsp;</p>
                                </div>
                                <Link
                                    to="/forgetPassword"
                                    style={{
                                        //width: '50%',
                                        height: '16px',
                                        textDecoration: 'none',
                                        fontFamily: 'Lato',
                                        fontStyle: 'normal',
                                        fontWeight: '300',
                                        fontSize: '14px',
                                        lineHeight: '16px',
                                        letterSpacing: '-0.0044em',
                                        color: 'rgba(64, 144, 247, 1)',
                                    }}
                                >{i18n.t('Mot de passe oublié?')}</Link>
                            </div>
                        </div>
                        <div className='BasicBtn'>
                            <Button
                                variant="contained"
                                type='submit'
                                size='medium'
                                onClick={(e) => {
                                    handleLoginSubmit(e);
                                }}
                                style={{
                                    ...buttonStylesBlue(!emailValid || !password || password==''),...{width:device=='desktop'?'43%':'100%',}
                                }}
                                //style={{
                                //    width: '43%',
                                //    color:'white',
                                //    background: '#214DCE',
                                //    borderRadius: '8px',
                                //    height:'56px',
                                //}}
                                disabled={!emailValid || !password || password==''}
                                startIcon={<ArrowForward />}
                            >
                                {i18n.t('Se connecter')}
                            </Button>
                            <ConnectOAuth2 width={device=='desktop'?'60%':'100%'}/>
                        </div>
                        {device!='desktop' &&
                        <>
                            <div className='rect127434'>
                                <div
                                    style={{width:'47%'}}
                                    ref={divRef}
                                >
                                    <DrawLine width={width}/>
                                </div>
                                <span style={{width:'6%',textAlign:'center'}}>Ou</span>
                                <div style={{width:'47%'}}>
                                    <DrawLine width={width}/>
                                </div>
                            </div>
                            <div className='BtnSinscrire'>
                                <span className='Vousnavezpas'>{i18n.t('Vous n\'avez pas de compte ?')} &nbsp; &nbsp;</span>
                                <div className='BtnSinscrireS'>
                                    <Button
                                        variant="outlined"
                                        //style={{
                                        //    width: '131px',
                                        //    borderRadius: '8px',
                                        //}}
                                        style={{...buttonStyles(false),...{height:'38px'}}}
                                        onClick={() => navigate('/register')}
                                        startIcon={<ArrowForward />}
                                    >
                                        {i18n.t('S\'inscrire')}
                                    </Button>
                                </div>
                            </div>
                        </>
                        }
                    </form>
                }
            </div>
        </div>
    );
}

export default Login2FA;